import { useCallback, useContext } from 'react';

import { TrackerContext } from '@context/tracker';

function useTracker() {
  const tracker = useContext(TrackerContext);

  const setUserId = useCallback(
    (userId) => {
      tracker.setUserId(userId);
    },
    [tracker]
  );

  const trackEvent = useCallback(
    (name, props) => {
      if (!tracker.isReady) {
        return;
      }
      return tracker.eventTracker(name, { source_app: 'Ajaib Stock', ...props });
    },
    [tracker]
  );

  const resetTracker = useCallback(() => tracker.resetTracker(), [tracker]);

  return { isReady: tracker.isReady, setUserId, trackEvent, resetTracker };
}

export default useTracker;
